import React from 'react';

/**
 * Faint cream ground markings seen from above: the boundary, the inner circle
 * and the pitch with its creases. Purely decorative.
 */
export function FieldLines({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 800 800" className={`pointer-events-none ${className}`} fill="none" aria-hidden="true" data-id="element-130" data-mp="qwnp1e410jv">
      <g stroke="#F5F0DC" strokeLinecap="round" data-id="element-131" data-mp="5qj1bbxuoit7">
        <circle cx="400" cy="400" r="390" strokeOpacity=".07" strokeWidth="2" data-id="element-132" data-mp="tfbtqyf9k8j2" />
        <circle cx="400" cy="400" r="230" strokeOpacity=".08" strokeWidth="2" strokeDasharray="10 12" data-id="element-133" data-mp="ydwur02caw8k" />
        <rect x="372" y="290" width="56" height="220" rx="4" strokeOpacity=".10" strokeWidth="2" data-id="element-134" data-mp="jp8yssol0ki3" />
        <path d="M352 318 H448 M352 482 H448 M372 300 H428 M372 500 H428" strokeOpacity=".12" strokeWidth="2" data-id="element-135" data-mp="omsbvp9jmr8g" />
        <path d="M392 306 V312 M400 306 V312 M408 306 V312 M392 488 V494 M400 488 V494 M408 488 V494" strokeOpacity=".16" strokeWidth="2" data-id="element-136" data-mp="1cc3gjhu0l5rv" />
      </g>
    </svg>;
}